import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { SnWidget } from '@lib/api/entities';
import { SnOperationalViewsAPI } from '@lib/api/services';

@Component({
  selector: 'sn-op-widget-dialog-view',
  templateUrl: './op-widget-dialog-view.component.html',
  styleUrls: ['./op-widget-dialog-view.component.scss'],
})
export class OpWidgetDialogViewComponent implements OnInit, OnDestroy {
  private readonly _undock$ = new Subject<SnWidget>();
  private readonly _destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public widget: SnWidget,
    private readonly _operationalViewsAPI: SnOperationalViewsAPI,
    private readonly _dialogRef: MatDialogRef<OpWidgetDialogViewComponent>,
  ) {}

  get undock$(): Observable<SnWidget> {
    return this._undock$.asObservable();
  }

  public ngOnInit(): void {}

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public onWidgetUpdated(widget: SnWidget): void {
    this._operationalViewsAPI
      .updateViewWidget(widget.operationalView, widget.id, widget)
      .pipe(takeUntil(this._destroy$))
      .subscribe();
  }

  public dock(): void {
    this.widget.popout = false;
    this._dialogRef.close();
  }
}
